import BaseTheme from '../variant/base';
export default BaseTheme;